// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Usuarios_UploadImagemPerfilInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /usuarios/uploadImagemPerfil/{sub}
 *
 * Validates input for uploading a user profile image.
 * Multipart form: inputImagem (file). The {sub} comes from the URL.
 */
import { registerContract } from './validate'

export interface Usuarios_UploadImagemPerfilInput {
_files: unknown[]
}

registerContract('Usuarios_UploadImagemPerfilInput', {
  _files: { type: 'array',   required: true },
})
